import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import { object } from 'underscore';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { StoreInfoService } from 'src/app/store-info.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-gallery',
  templateUrl: './theme-list.component.html',
  styleUrls: ['./theme-list.component.scss']
})
export class ThemeListComponent implements OnInit {

  @ViewChild('previewThemeModal') previewThemeModal: TemplateRef<any>;
  selectIsLoadingId = [];

  modalRef;

  previewedTheme;

  store_id;
  bearer;
  isLoading;

  onerror = [];
  themeList = [];
  themeName = '';
  themeselectId = '';
  previewImage = '';


  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private router: Router,
    private formBuilder: FormBuilder,
    private utils: UtilitiesService,
    private storeInfoService: StoreInfoService,) { }

  // The store's theme_id is the preset it last applied (estore/update saves
  // the preset_id there), so it marks the card that is in use. The live
  // stream, not getStoreInfos()' single value, so the refresh that follows
  // Apply moves the badge even if it lands after this page opens.
  currentThemeId$ = this.storeInfoService
    .getStoreInfo()
    .pipe(map((info) => Number(info?.theme_id) || null));

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    this.getThemePresetList();
  }

  public getThemePresetList(): void {
    this.isLoading = true;
    this.svc.getThemePresetList(this.bearer).subscribe((res: any) => {
      this.isLoading = false;
      this.themeList = res?.data ?? [];
    });
  }

  setErrorImg(e, media_id) {
    this.onerror[media_id] = true;
    e.target.src = 'https://fiv5s-files.s3.ap-southeast-1.amazonaws.com/product/estore-missing-product.png';
  }

  previewThemePreset(themeId) {
    this.previewedTheme = this.themeList.find(theme => theme.preset_id == themeId);
    this.themeselectId =  this.previewedTheme.preset_id;
    this.themeName = this.previewedTheme.preset_name;
    this.previewImage = this.previewedTheme.preview_img;
    localStorage.setItem('themeName', this.themeName);
    localStorage.setItem('themeselectId', this.themeselectId);
    localStorage.setItem('previewImage', this.previewImage);
    // this.modalRef = this.modalService.open(this.previewThemeModal, { size: 'lg' });
  }

  closeModal(e) {
    this.modalRef.close(true);
  }

  selectThemePreset(themeId) {
    console.log(`selectThemePreset`, { themeId })
    this.selectIsLoadingId.push(themeId);

    console.log('test',this.bearer);
    this.svc.selectTheme(themeId, this.bearer).subscribe((res: any) => {
      console.log('selectThemePreset', { res })

      this.utils.notify.showSuccess(this.utils.translate("Updated Successfully!"));

    },
      error => {
        console.log('ERROR', { error })
        this.utils.notify.showError(this.utils.translate("Update Failed!"));
      });
  }

  addPresetIdToLoading(preset_id) {

  }

  removePresetIdFromLoading(preset_id) {

  }

  protected readonly localStorage = localStorage;
}
